/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { checkUseOcrExperiment } from './check';

/** 极简流程里的OCR页面 */
export const VerifyCreditIdentityLoader = () => import(
  /* webpackChunkName: "async-verify-credit-identity" */ '@/views_v2/verify-credit/components/verify-stages/identity'
);

/** 新OCR页面 */
export const OcrIdentityLoader = () => import(
  /* webpackChunkName: "async-client-ocr-identity" */ '@/widgets/ocr-identity/index.vue'
);

let preloadingVerifyCreditIdentity = false;
export const preloadVerifyCreditIdentity = async () => {
  if (preloadingVerifyCreditIdentity) return;
  preloadingVerifyCreditIdentity = true;

  try {
    const isUseClientOcr = await checkUseOcrExperiment();

    if (isUseClientOcr) {
      OcrIdentityLoader();
    } else {
      VerifyCreditIdentityLoader();
    }
  } catch {
    // 无需处理
  }

  preloadingVerifyCreditIdentity = false;
};
